// Default short name for a freshly-created superset (Antenore, inbox 963ca6f2:
// "sul nome default bisogna trovare un sistema corto di abbreviazione").
// Pure + i18n-agnostic: takes the member display names and returns a compact
// label like "Pan+Rem+Tra" — first 3 letters of up to 3 members, "+N" tail
// for the rest. The user can rename it (the name is editable); this is only
// the seed.

const MAX_PARTS = 3;
const LETTERS = 3;

const part = (name: string): string => {
  const trimmed = name.trim();
  if (trimmed.length === 0) return '?';
  // First word's first LETTERS letters, capitalised. Strips spaces so a
  // two-word name collapses to its head ("Bird Dog" → "Bir").
  const head = trimmed.split(/\s+/)[0] ?? trimmed;
  const slice = head.slice(0, LETTERS);
  return slice.charAt(0).toUpperCase() + slice.slice(1);
};

export function supersetAbbrev(memberNames: ReadonlyArray<string>): string {
  const names = memberNames.filter((n) => n.trim().length > 0);
  if (names.length === 0) return '';
  const shown = names.slice(0, MAX_PARTS).map(part).join('+');
  const extra = names.length - MAX_PARTS;
  return extra > 0 ? `${shown}+${extra}` : shown;
}
